import { ITrackingProductPageBaseParameters } from './baseParameters';

export type ITrackingFillRewardCampaignParameters = Pick<
  ITrackingProductPageBaseParameters,
  'productUid' | 'productName'
>;

export const fillRewardCampaign = (
  parameters: ITrackingFillRewardCampaignParameters,
) => {
  const { productName, productUid } = parameters;

  return {
    reward_campaign_name: productName,
    reward_campaign_id: productUid,
  } as const;
};
